//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { HEADER, MOBILE, TABLET } from '@/scripts/constants/media-query'
import { mapGetters } from 'vuex'

export default {
  name: 'rb-header-message-bar-button',
  props: {
    isClicked: { type: Boolean, default: false },
    isPageScrolled: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters(['translation']),
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET || this.$mq === HEADER
    },
  },
  methods: {
    emitClick() {
      this.$emit('buttonClicked')
    },
  },
}
